module.exports = __webpack_public_path__ + "static/logo-feeb45e9efe3218b40543522f1d20a01.png";